import { render } from "./CardField.vue?vue&type=template&id=24af7bd9&scoped=true"
import script from "./CardField.vue?vue&type=script&lang=js"
export * from "./CardField.vue?vue&type=script&lang=js"

import "./CardField.vue?vue&type=style&index=0&id=24af7bd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24af7bd9"]])

export default __exports__